import React, { useState,useContext } from "react";
import { Button, Label, Icon, Card } from "@pmi/nyx-design-system";
import { SidebarContext } from "../../context/sidebarcontext";
import { ApiContext } from "../../context/apicontext";

// Left side Density and Coverage tab code
const CoverageSection = ({ title, subtitle, data, indicatorKey, actualKey, benchmarkKey }) => (
    <>
        <Label className="fs-6 mt-4 d-flex">{title}</Label>
        <Label className="small mb-3 coverage-subtitle">{subtitle}</Label>
        <div className="demographics-data small">
            <Label className="d-flex align-items-center text-transform-none fw-bold small">
                <Icon color="dark" name="map-2" size="small" className="me-2" />Proximity
            </Label>
            <Label className="text-transform-none fw-bold small">Actual</Label>
            <Label className="d-flex align-items-center fw-bold small">
                <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                    <Icon color="dark" name="clipboard-list" size="small" />
                </div>
                Benchmark
            </Label>
        </div>
        {data.map((row) => (
            <div key={row[indicatorKey]} className="tab-data">
                <div className="d-flex align-items-center">
                    <Icon color="#E0E0E0" name="eye" size="small" className="me-2" />
                    <Label className="text-transform-none">{row[indicatorKey]}</Label>
                </div>
                <span className="text-transform-none">{row[actualKey]}</span>
                <span className="text-transform-none d-flex align-items-center benchmark-up">
                    <Icon color="#2D8121" name="arrow-up" size="medium" />{row[benchmarkKey]}
                </span>
            </div>
        ))}
    </>
);

function DensityCoverage() {
    const [selectedBtn, setSelectedBtn] = useState("Drive");
    const { densityData } = useContext(ApiContext);

    const handleButtonClick = (mode) => { setSelectedBtn(mode) };

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between">
                <Label className="s-16 fw-bold">LAS/LAU coverage</Label>
                <div role="group" className="flex catchment-btn-wrapper rounded-2 p-1 w-full">
                    {["Drive", "Walk"].map((option) => (
                        <Button key={option} size="small" variant={selectedBtn === option ? "black" : "white"}
                            className={
                                (selectedBtn === option
                                    ? "active bg-white text-black border rounded-2 py-2"
                                    : "border-0 py-0 bg-transparent")
                                + " px-3 w-50 text-center"
                            }
                            onClick={() => handleButtonClick(option)}
                        >
                            {option}
                        </Button>
                    ))}
                </div>
            </div>

            <CoverageSection 
                title="P1 resellers"
                subtitle="LAS coverage at given proximity"
                data={densityData.P1_resellers.LAS_coverage_at_given_proximity}
                indicatorKey="Proximity"
                actualKey="Actual"
                benchmarkKey="Benchmark"
            />
            <CoverageSection 
                title="Experiential touchpoints"
                subtitle="LAU coverage at given proximity"
                data={densityData.Experiential_touchpoints.LAU_coverage_at_given_proximity}
                indicatorKey="Proximity"
                actualKey="Actual"
                benchmarkKey="Benchmark"
            />
            <CoverageSection 
                title="Touchpoint count"
                subtitle="Touchpoint_count"
                data={densityData.Touchpoint_count}
                indicatorKey="Type"
                actualKey="Actual"
                benchmarkKey="Benchmark"
            />
            <CoverageSection 
                title="Channel mix"
                subtitle="Channel mix"
                data={densityData.Channel_mix}
                indicatorKey="Indicator"
                actualKey="Actual"
                benchmarkKey="Benchmark"
            />
            <CoverageSection 
                title="Density of touchpoints"
                subtitle="Density of touchpoints"
                data={densityData.Density_of_touchpoints}
                indicatorKey="Indicator"
                actualKey="Actual"
                benchmarkKey="Benchmark"
            />

            <Card className="mt-4 request-card" width="100%" buttonIsLink buttonLabel="Create a request" buttonPosition="left" orientation="vertical" title="NEED TOP DOWN MODELING?">
                You can ask the analytics team to make top-down modeling for this territory.
            </Card>
        </div>
    );
}

export default DensityCoverage;